module.exports = __webpack_public_path__ + "img/Frame 716.8c402192.png";